import { useEffect } from "react";
import { useLocalStorage } from "@/hooks/useLocalStorage";
import { LocalStorageKeys } from "@/shared/types/common";

export function useScrollIntoPriceTable(
	pricingRef: React.RefObject<HTMLDivElement | null>,
	readyToUpgrade = false,
) {
	const [redirectPath, setValue] = useLocalStorage(
		LocalStorageKeys.redirectPath,
		null,
	);

	useEffect(() => {
		if ((redirectPath || readyToUpgrade) && pricingRef.current) {
			setTimeout(() => {
				pricingRef.current?.scrollIntoView({ behavior: "smooth" });
				setValue(null);
			}, 1000);
		}
	}, [redirectPath, setValue, pricingRef.current, readyToUpgrade]);
}
